import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { tableModel } from '../../../components/table/model/tableModel';
import { FilterObjectCatalog } from '../../../models/filters/filter-object-catalog';
import { ObjectCatalogService } from '../../../services/object-catalog.service';

@Component({
  selector: 'app-object',
  standalone: false,
  templateUrl: './object.component.html',
  styleUrl: './object.component.css'
})
export class ObjectComponent {

  @ViewChild(TableComponent) objectsCatalogTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'},
      {columnName:'Codigo',columnValue:'attribute'},
      {columnName:'Tipo Beneficio',columnValue:'objectTypeDes'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterObjectCatalog: FilterObjectCatalog = new FilterObjectCatalog;
  advancedSearch: boolean = false;
  
  private objectCatalogService = inject(ObjectCatalogService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterObjectCatalog = new FilterObjectCatalog();
    this.searchObjectGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchObjectGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/objectsCatalog/edit', event.id]);
  }
  addNewObjectGroup(){
    this.router.navigate(['/objectsCatalog/edit', 0]);
  }

  searchObjectGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchObjectGroupPaginator();
  }

  searchObjectGroupPaginator(){
    this.loading = true;

    this.objectCatalogService.findAllPageableObjectCatalog(this.filterObjectCatalog, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.objectsCatalogTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
